import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { AiOutlineQrcode } from 'react-icons/ai';
import { FiCamera } from 'react-icons/fi';
import StickyFooter from '../../../components/StickyFooter';
import { CssTextField } from '../../../components/Forms/styles';

import {
  LPTitle,
  LPText,
  Center,
  BodyWrapper,
} from '../../styles';
import PageLayout from '../../shared/PageLayout';
import { PageContext } from '../context';
import AlertMessage from '../../../components/AlertMessage';

const QRScannerPageContent = () => {
  const location = useLocation();
  const [returnPath, setReturnPath] = useState('');
  const [alertData, setAlertData] = useState({
    open: false,
    handleClose: () => false,
    variant: 'error',
    message: '',
    duration: 3000,
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAlertData({ ...alertData, open: false });
  };

  const showError = (error) => {
    const newData = {
      ...alertData,
      open: true,
      variant: 'error',
      message: error,
      handleClose,
    };
    setAlertData(newData);
  };

  useEffect(() => {
    const { state } = location;
    if (state) {
      if (state.error) showError(state.error);
      setReturnPath(state.prevLocation);
    }
  }, [location]);

  const {
    setField,
    isLoggedIn,
    isFormValid,
    login,
  } = useContext(PageContext);

  if (isLoggedIn && returnPath !== '') {
    return <Redirect to={returnPath} />;
  }

  return (
    <PageLayout isDark>
      <Center>
        <BodyWrapper>
          {!isLoggedIn && (
            <>
              <LPTitle upcase center>
                <span className="thin">
                  Mobile
                </span>
                Check-in
              </LPTitle>
              <CssTextField
                fullWidth
                margin="dense"
                variant="outlined"
                label="Pass Code"
                onChange={(e) => setField('passcode', e.target.value)}
              />
            </>
          )}

          {isLoggedIn && (
            <>
              <LPTitle upcase center>
                <span className="thin">
                  Guest
                </span>
                Check in
              </LPTitle>

              <LPText flex>
                Use
                <FiCamera />
                <b> camera </b>
                to scan
                <AiOutlineQrcode />
                <b> QR code </b>
                of your guests.
              </LPText>
            </>
          )}
        </BodyWrapper>
        <AlertMessage {...alertData} />
      </Center>

      {!isLoggedIn && (
        <StickyFooter
          disabled={!isFormValid}
          title="Sign in"
          handleOnclick={login}
        />
      )}
    </PageLayout>
  );
};

export default QRScannerPageContent;
